import type { RankingStatKey } from '../types/rankings';

/**
 * SF-159 Component 7: leaderboard cap. Drives the mock hook's slice; the toolbar caption reads
 * `entries.length`/`totalCount` directly, not this constant, once a real backend enforces its own
 * cap server-side — avoids a second source of truth.
 */
export const RANKING_TOP_N = 100;

/**
 * Exact mobile card-list cap — no further pagination/scroll mechanism (Phase 3 Critical Issue 7).
 */
export const RANKING_MOBILE_CARD_CAP = 12;

/**
 * Ordered stat list — single source for the desktop table's column order, the mobile sort
 * `<select>`'s options, and any future `it.each(RANKING_STATS.map(...))` test (CLAUDE.md's
 * `WORLD_ITEMS`-style precedent for surviving a future stat addition without a hand-copied test
 * array going stale).
 */
export const RANKING_STATS: readonly { key: RankingStatKey; label: string }[] = [
  { key: 'networth', label: 'Net Worth' },
  { key: 'land', label: 'Land' },
  { key: 'honour', label: 'Honour' },
  { key: 'warsWon', label: 'Wars Won' },
];

interface RankingStatFields {
  land: number;
  networth: number;
  honour: number | null;
  warsWon: number | null;
}

/**
 * Single accessor for a `RankingStatKey`'s numeric value, shared by `useRankings.ts`,
 * `RankingsTable.tsx`, and `MobileRankingsShell.tsx` — previously three independent copies of the
 * same switch.
 */
export function rankingStatValue(row: RankingStatFields, key: RankingStatKey): number {
  switch (key) {
    case 'land':
      return row.land;
    case 'networth':
      return row.networth;
    case 'honour':
      return row.honour ?? 0;
    case 'warsWon':
      return row.warsWon ?? 0;
  }
}
